import ipxStaticRuntime_36yBsvbBqcH4exZi3HP70DURkYUhRvmQRpbtlbxx3BoLQ from '/home/runner/work/qx-lunarheart/qx-lunarheart/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'

export const imageOptions = {
  screens: {"sm":640,"md":768,"lg":1024,"xl":1280,"2xl":1536},
  presets: {},
  domains: [],
  alias: {},
  densities: [1,2],
  format: ["webp"],
  quality: undefined,
  /** @type {"ipxStatic"} */
  provider: "ipxStatic",
  providers: {
      ['ipxStatic']: { setup: ipxStaticRuntime_36yBsvbBqcH4exZi3HP70DURkYUhRvmQRpbtlbxx3BoLQ, defaults: {} }
  }
}
